import toast from 'react-hot-toast';
import {AxiosResponse} from 'axios'

import badRequestHandler from './errorHandlers/badRequestHandler';
import unauthorizedHandler from './errorHandlers/unauthorizedHandler';
import serviceErrorHandler from './errorHandlers/serviceErrorHandler';
import internalServerErrorHandler from './errorHandlers/internalServerErrorHandler';
import conflictErrorHandler from './errorHandlers/conflictErrorHandler';
import notFoundHandler from './errorHandlers/notFoundHandler';
import accessDeniedHandler from './errorHandlers/accessDeniedHandler';

const defaultHandler = (error: any) => {
  toast.error(error.data.message, {
    position: 'top-left',
    duration: 5000,
  });
}


type ErrorHandlers = {
  400: (error: any) => void,
  401: (error: any) => void,
  503: (error: any) => void,
  500: (error: any) => void,
  409: (error: any) => void,
  404: (error: any) => void,
  403: (error: any) => void
}

const errorHandlers: ErrorHandlers = {
  400: badRequestHandler,
  401: unauthorizedHandler,
  503: serviceErrorHandler,
  500: internalServerErrorHandler,
  409: conflictErrorHandler,
  404: notFoundHandler,
  403: accessDeniedHandler
}

const errorHandling = (error: AxiosResponse) => {
  try {
    errorHandlers[error.status as keyof ErrorHandlers] ? errorHandlers[error.status as keyof ErrorHandlers](error) : defaultHandler(error)
  } catch (error) {
    toast.error('چنانچه این مشکل بعد از چند لحظه همچنان ادامه داشت با واحد پشتیبانی تماس بگیرید.', {
      position: 'top-left',
      duration: 5000,
    });
  }
}

const codeError = () => {
  toast.error('چنانچه این مشکل بعد از چند لحظه همچنان ادامه داشت با واحد پشتیبانی تماس بگیرید.', {
    position: 'top-left',
    duration: 5000,
  });
}

const handleError = (error: any) => {
  if(error) {
    errorHandling(error?.response)
  }else {
    codeError()
  }
}

export default handleError;